import { FunctionComponent } from 'react';

import { Container } from '../Container';

import classes from './auth-card.module.scss';

export const AuthCard: FunctionComponent = ({ children }) => (
  <div className={classes.authCard}>
    <Container className={classes.form}>{children}</Container>
  </div>
);
